import { baseLabDrawSchema } from '../validations/shared/labDraw';
const shape = baseLabDrawSchema.shape;
export const labSpecimenFields = [
    { key: 'requisitionNumber', field: shape.requisitionNumber },
    { key: 'labReceiving', field: shape.labReceiving },
    { key: 'specimenPickup', field: shape.specimenPickup },
    { key: 'pickupTimeAndCourier', field: shape.pickupTimeAndCourier },
];
export const bloodDrawTestFields = [
    { key: 'bloodDrawTestsOrdered', field: shape.bloodDrawTestsOrdered, variant: 'tags' },
];
export const bloodDrawCustomTestFields = [
    { key: 'bloodDrawCustomTest', field: shape.bloodDrawCustomTest },
];
export const bloodDrawTubesFields = [
    { key: 'bloodDrawTubesCollected', field: shape.bloodDrawTubesCollected, variant: 'tags' },
];
export const venipunctureFields = [
    { key: 'bloodDrawSiteAccessed', field: shape.bloodDrawSiteAccessed },
    { key: 'bloodDrawNeedleGauge', field: shape.bloodDrawNeedleGauge },
    { key: 'bloodDrawAttempts', field: shape.bloodDrawAttempts },
    { key: 'bloodDrawDifficultAccess', field: shape.bloodDrawDifficultAccess, variant: 'tags' },
];
export const patientResponseFields = [
    { key: 'bloodDrawPatientTolerance', field: shape.bloodDrawPatientTolerance },
    { key: 'bloodDrawSiteCondition', field: shape.bloodDrawSiteCondition },
    { key: 'bloodDrawSpecimenIntegrity', field: shape.bloodDrawSpecimenIntegrity },
    { key: 'bloodDrawSharpsDisposal', field: shape.bloodDrawSharpsDisposal, variant: 'tags' },
    { key: 'bloodDrawSpecimenLabeling', field: shape.bloodDrawSpecimenLabeling, variant: 'tags' },
];
export const urineSpecimenFields = [
    { key: 'urineTestsOrdered', field: shape.urineTestsOrdered, variant: 'tags' },
    { key: 'urineCollectionMethod', field: shape.urineCollectionMethod },
    { key: 'urineSpecimenColor', field: shape.urineSpecimenColor },
    { key: 'urineOdor', field: shape.urineOdor },
    { key: 'urineVolumeAdequacy', field: shape.urineVolumeAdequacy },
    { key: 'urineDipstickResults', field: shape.urineDipstickResults },
    { key: 'urinePatientSymptoms', field: shape.urinePatientSymptoms, variant: 'tags' },
    { key: 'urineDisposal', field: shape.urineDisposal, variant: 'tags' },
];
export const woundCultureFields = [
    { key: 'woundCultureTypes', field: shape.woundCultureTypes, variant: 'tags' },
    { key: 'woundSiteCultured', field: shape.woundSiteCultured },
    { key: 'woundBedAppearance', field: shape.woundBedAppearance, variant: 'tags' },
    { key: 'woundCultureReason', field: shape.woundCultureReason },
];
export const specimenCollectionFields = [
    { key: 'specimenTypes', field: shape.specimenTypes, variant: 'tags' },
];
export const specimenCustomTypeFields = [
    { key: 'specimenCustomType', field: shape.specimenCustomType },
];
export const specimenNotesFields = [
    { key: 'specimenCollectionNotes', field: shape.specimenCollectionNotes },
];
export const resultsCommunicationFields = [
    { key: 'resultsRecipients', field: shape.resultsRecipients, variant: 'tags' },
    { key: 'resultsExpectedTurnaround', field: shape.resultsExpectedTurnaround },
    { key: 'resultsPriorReviewed', field: shape.resultsPriorReviewed },
    { key: 'resultsClinicalNarrative', field: shape.resultsClinicalNarrative },
];
